// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3Ess2","colCheckbox":"styles_colCheckbox__1ah-4"};